import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0584ebba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hidden sm:block" }
const _hoisted_2 = { class: "flex justify-content-between mx-auto wp1200 py-4" }
const _hoisted_3 = { class: "text-2xl font-bold" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_TE_bullet_list font-bold" }, null, -1))
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = { class: "map" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_x text-lg" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "text-primary text-base font-bold mr-3" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_x text-lg" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "text-primary text-base font-bold mr-3" }
const _hoisted_15 = { class: "flex gap-4 wp1200 absolute left-0 right-0 top-0 mt-3 pointer-events-none" }
const _hoisted_16 = { class: "relative flex align-items-center w-22rem pointer-events-auto" }
const _hoisted_17 = {
  key: 0,
  class: "icon-warpit_icon_search absolute right-0 mr-3"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_TE_bullet_list font-bold text-base" }, null, -1))
const _hoisted_19 = {
  key: 0,
  class: "wp1200 py-4 px-4"
}
const _hoisted_20 = {
  key: 0,
  class: "no-scrollbar flex sm:flex-wrap gap-3 sm:gap-0 sm:-mt-2 sm:-ml-2 sm:-mr-2 overflow-x-scroll"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Map = _resolveComponent("Map")!
  const _component_GMapAutocomplete = _resolveComponent("GMapAutocomplete")!
  const _component_Button = _resolveComponent("Button")!
  const _component_NearbyCard = _resolveComponent("NearbyCard")!
  const _component_Information = _resolveComponent("Information")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.getTitle(_ctx.$route.params.feature as string)), 1),
        (_ctx.$route.name === 'InfoMap')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'InfoList' }))),
              class: "flex align-items-center gap-2 border-none bg-white text-primary font-bold text-lg cursor-pointer"
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("bikes.show_list")), 1),
              _hoisted_4
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Map, {
          markers: _ctx.markers,
          geoJson: _ctx.geoJson,
          selectedGeoJson: _ctx.selectedGeoJson,
          center: _ctx.center,
          zoom: _ctx.zoom,
          onCenterChanged: _ctx.updateCenter,
          onZoomChanged: _ctx.updateZoom,
          onSelectMarker: _ctx.selectMarker,
          onSelectGeoJson: _ctx.selectGeoJson,
          markerInfoOnHover: false,
          "navigate-on-click": false
        }, {
          info: _withCtx(({ payload }) => [
            _createElementVNode("div", {
              class: "relative flex flex-column gap-2 p-2 w-15rem cursor-pointer",
              onClick: ($event: any) => (_ctx.selectItem(payload))
            }, [
              _createElementVNode("div", {
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.unselectPoint && _ctx.unselectPoint(...args)), ["stop"])),
                class: "absolute right-0 top-0"
              }, _hoisted_9),
              _createElementVNode("span", _hoisted_10, _toDisplayString(payload.name), 1)
            ], 8, _hoisted_7)
          ]),
          geoJsonInfo: _withCtx(({ payload }) => [
            _createElementVNode("div", {
              class: "relative flex flex-column gap-2 p-2 cursor-pointer",
              onClick: ($event: any) => (_ctx.selectItem(payload))
            }, [
              _createElementVNode("div", {
                onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.unselectPoint && _ctx.unselectPoint(...args)), ["stop"])),
                class: "absolute right-0 top-0"
              }, _hoisted_13),
              _createElementVNode("span", _hoisted_14, _toDisplayString(payload.name), 1)
            ], 8, _hoisted_11)
          ]),
          _: 1
        }, 8, ["markers", "geoJson", "selectedGeoJson", "center", "zoom", "onCenterChanged", "onZoomChanged", "onSelectMarker", "onSelectGeoJson"])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_GMapAutocomplete, {
            class: "addressSearch",
            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.address = $event.target.value)),
            onPlace_changed: _ctx.setAddress,
            options: {
            componentRestrictions: { country: 'si' },
          },
            value: _ctx.address,
            placeholder: _ctx.$t('global.search'),
            id: "address",
            maxlength: "255"
          }, null, 8, ["onPlace_changed", "value", "placeholder"]),
          (_ctx.address === null)
            ? (_openBlock(), _createElementBlock("i", _hoisted_17))
            : _createCommentVNode("", true),
          (_ctx.address !== null)
            ? (_openBlock(), _createElementBlock("i", {
                key: 1,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.address = null)),
                class: "icon-warpit_icon_x absolute right-0 mr-3 cursor-pointer"
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_Button, {
          class: "parkingRoundButton sm:hidden pointer-events-auto",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push({ name: 'InfoList' })))
        }, {
          default: _withCtx(() => [
            _hoisted_18
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.selectedItem === null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          (_ctx.nearestItems && _ctx.nearestItems.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nearestItems, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    class: "grid sm:col-6 sm:mr-2 sm:mt-1"
                  }, [
                    _createVNode(_component_NearbyCard, {
                      class: "w-20rem sm:w-12",
                      item: item,
                      onSelected: _ctx.selectItem
                    }, null, 8, ["item", "onSelected"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createBlock(_component_Information, {
          key: 1,
          item: _ctx.selectedItem,
          onBack: _ctx.unselectPoint
        }, null, 8, ["item", "onBack"]))
  ], 64))
}